import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';

// -- entities
import AvailabilityHour from 'PMT/entities/menu/AvailabilityHour';


class AvailabilityHourView extends Component {

  static defaultProps = {
    readOnly: false
  };

  static propTypes = {
    availabilityHour: PropTypes.objectOf(AvailabilityHour).isRequired,

    // params: availabilityHour (AvailabilityHour)
    onDelete: PropTypes.func.isRequired,

    readOnly: PropTypes.bool
  };

  // -- actions
  onDelete = () => {
    this.props.onDelete(this.props.availabilityHour);
  };

  // -- renderers

  render() {
    /**
     * We want both value to be null because when adding a new availabilityHour
     * opening is set to null and formatted to 00:00
     */
    if (this.props.availabilityHour.opening === null && this.props.availabilityHour.closing === null) {
      return null
    }

    return (
      <div className="availability_hours_for_day__hour">
        {this.props.availabilityHour.getFormatted()}
        {!this.props.readOnly &&
          <span>
            &nbsp;&nbsp;&nbsp;
            <a
              className="link"
              onClick={this.onDelete}
            >
              <i className="fa fa-trash" />
            </a>
          </span>
        }
      </div>
    );
  }

}

export default AvailabilityHourView;



// WEBPACK FOOTER //
// ./scripts/pages/menu/components/availabilityHours/AvailabilityHourView.js